// extracted by extract-css-chunks-webpack-plugin
module.exports = {"slide":"slide-3OMdk","title":"title-LIX91","page":"page-1n7Q9"};